import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { ExternalLink } from "../Link/ExternalLink";
import { SocialButtons } from "./SocialButtons";
import { MenuMobile } from "./MenuMobile";
import { useLocation } from "react-router-dom";

export interface TopBarProps {
  menuItems: any[];
  visibleItems: any[];
  hiddenItems: any[];
  anchorEl: HTMLElement | null;
  handleMenuOpen: (event: any) => void;
  handleMenuClose: () => void;
}

export const TopBar = ({
  menuItems,
  visibleItems,
  hiddenItems,
  anchorEl,
  handleMenuOpen,
  handleMenuClose,
}: TopBarProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(800));
  const location = useLocation();

  const styles = {
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 76,
      minHeight: "auto!important",
    },
    box: {
      display: isSmallScreen ? "none" : "flex",
      gap: 6,
      justifyContent: "space-between",
      alignItems: "center",
      marginRight: 1,
    },
    boxLink: {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      "&:hover": {
        color: "#fff",
        "& svg": {
          fill: "#F6B0CE",
        },
        "& a": {
          fill: "#fff",
        },
      },
    },
    boxLinkSpan: {
      display: "flex",
      alignItems: "center",
      mr: 1,
      height: "16px",
      "& svg": {
        fontSize: "18px",
      },
    },
    typography: {
      fontSize: "16px",
      fontFamily: "Montserrat",
    },
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#001737",
          borderBottom: "3px solid #F6B0CE",
        }}
        className="app-bar-container"
      >
        <Toolbar
          sx={styles.toolbar}
          className=" xvia-header-spacing xvia-header-container xvia-header-spacing"
        >
          {!isSmallScreen && <SocialButtons />}
          <Box sx={styles.box}>
            {visibleItems.map((item) => {
              const isActive =
                item.path === "/app/catalog/"
                  ? location.pathname === item.path
                  : location.pathname === item.path ||
                    location.pathname.startsWith(item.path + "/");
              return (
                <ExternalLink key={item.path} link={item.path} target="_self">
                  <Box
                    sx={{
                      ...styles.boxLink,
                      color: isActive ? "#3fa1ff" : "#999eb0",
                      "& svg": {
                        fill: isActive ? "#3fa1ff" : "#999eb0",
                      },
                      "& a": {
                        fill: isActive ? "#3fa1ff" : "#999eb0",
                      },
                    }}
                  >
                    <Box
                      component="span"
                      sx={styles.boxLinkSpan}
                      aria-hidden="true"
                    >
                      {item.icon}
                    </Box>
                    <Typography variant="body1" sx={styles.typography}>
                      {item.label}
                    </Typography>
                  </Box>
                </ExternalLink>
              );
            })}
          </Box>
          <MenuMobile
            hiddenItems={hiddenItems}
            handleMenuOpen={handleMenuOpen}
            isSmallScreen={isSmallScreen}
            anchorEl={anchorEl}
            handleMenuClose={handleMenuClose}
          />
        </Toolbar>
      </AppBar>
      {isSmallScreen && (
        <Box
          sx={{
            background: "#001737",
            padding: 1,
            display: "flex",
            justifyContent: "flex-start",
            paddingLeft: 16,
          }}
        >
          <SocialButtons />
        </Box>
      )}
    </>
  );
};
